import React from "react";
import Navbar from "../molecules/Navbar";
import Footer from "../molecules/Footer";
import styled from "styled-components";
import { positions, Provider as AlertProvider } from "react-alert";
import { Alert } from "react-bootstrap";
import { Helmet } from "react-helmet"
import favicon from '../../../static/favicon.png'

const options = {
	position: positions.BOTTOM_LEFT,
	timeout: 3000,
	containerStyle: {
		zIndex: 9999,
	},
};
const AlertTemplate = ({ style, message, close }) => {
	return (
		<div style={{ ...style, background: "red", color: "white" }}>
			<Alert onClose={close} dismissible>
				{message}
			</Alert>
		</div>
	);
};

const Layout = ({ children, landingPage }) => {
	return (
		<>
			<Navbar landingPage={landingPage} />
			<AlertProvider template={AlertTemplate} {...options}>
				<Main>{children}</Main>
			</AlertProvider>
			<Footer />
		</>
	);
};

export default Layout;

const Main = styled.main`
	padding-top: 72px;
`;
